import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const saveDashboardPreferenceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    saveDashoboardPreference: builder.mutation({
      query: ({ body, patientProfileId, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/patientpreference/${patientProfileId}/dashboard-Preference`,
          method: "POST",
          data: body,
          headers,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "DashboardPreference", id: arg.mrnId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useSaveDashoboardPreferenceMutation } =
  saveDashboardPreferenceApi;
export default saveDashboardPreferenceApi;
